import { useDocumentTitle } from "@/hooks/useDocumentTitle";

/**
 * Component that manages document title across all pages
 * This component should be placed inside the BrowserRouter
 */
export const DocumentTitleManager = () => {
  useDocumentTitle();
  return null; // This component doesn't render anything
};
